export default "__VITE_ASSET__COAXfbqF__"